import { IElementToSimpleSamElementsMapper } from './elementToSimpleSapElementsMapper';
import { ISimpleSapElement } from '@/models/api/models/simpleSapElement';
import Element, { ElementType } from '@/models/element';
import { Product } from '@/store/modules/product';
import store from '@/store';

export abstract class BaseElementToSimpleSapElementMapper implements IElementToSimpleSamElementsMapper {

    protected readonly metalLegs = 'NMWS';

    protected readonly depthMap = new Map([[255, 1], [355, 2], [455, 3], [555, 4]]);
    protected readonly widthMap = new Map([[455, 1], [910, 2], [1365, 3], [1820, 4]]);
    protected readonly heightMap = new Map([[455, 1], [910, 2], [1365, 3], [1820, 4]]);

    protected get body(): Element {
        return store.getters.body;
    }
    protected get product(): Product {
        return store.getters.product;
    }
    protected get depth(): number {
        return this.depthMap.get(this.product.depth);
    }
    protected get width(): number {
        return this.widthMap.get(this.product.width);
    }
    protected get height(): number {
        return this.heightMap.get(this.product.height);
    }
    protected get hasLegsSupport(): boolean {
        const elements: Element[] = store.getters.scene.elements;
        return elements.some((x) =>
            x.type === ElementType.LEGS &&
            x.shaderName === 'ShaderNPodp',
        );
    }

    public abstract map(element: Element): ISimpleSapElement[];

    protected formatType(type: string, dim1: any, dim2: any): string {
        return `${type}_${dim1}_${dim2}`;
    }

    protected toColor(element: Element): string {
        const shader = element.shaderName;
        if (shader === 'Shader6458' ||
            shader === 'ShaderSzuflada' ||
            shader === 'Shader01Podp') { return 'BIA'; }
        if (shader === 'Shader02Podp' ||
            shader === 'ShaderU899') { return 'CZA'; }
        if (shader === 'ShaderH3162') { return 'D_BR'; }
        if (shader === 'ShaderH3157') { return 'D_JA'; }
        if (shader === 'ShaderH3396') { return 'D_MI'; }
        if (shader === 'ShaderH3325') { return 'DAB_CIE'; }
        if (shader === 'ShaderU599') { return 'IND'; }
        if (shader === 'ShaderU830') { return 'NUD'; }
        if (shader === 'ShaderU163') { return 'SZAF'; }
        if (shader === 'ShaderU8101') { return 'SZARY'; }
        if (shader === 'ShaderU606') { return 'ZIE'; }
        return '';
    }

    protected toHandleType(element: Element): string {
        const shader = element.shaderName;
        if (!element) { return this.formatType('SPD', 0, 12); }
        if (shader === 'ShaderU06Siro') { return this.formatType('UDJ', 0, 1); }
        if (shader === 'ShaderU02Alus') { return this.formatType('UDJ', 0, 2); }
        if (shader === 'ShaderU05Schwinn') { return this.formatType('UDJ', 0, 3); }
        if (shader === 'ShaderU07Schwinn') { return this.formatType('UDJ', 0, 4); }
        if (shader === 'ShaderU03Schwinn') { return this.formatType('UDJ', 0, 5); }
        if (shader === 'ShaderU04Schwinn') { return this.formatType('UDJ', 0, 6); }
        if (shader === 'ShaderU01Siro') { return this.formatType('UDD', 0, 7); }
        if (shader === 'ShaderU09Siro') { return this.formatType('UDD', 0, 8); }
        if (shader === 'ShaderU11Schwinn') { return this.formatType('UDD', 0, 9); }
        if (shader === 'ShaderU10Schwinn') { return this.formatType('UDD', 0, 10); }
        if (shader === 'ShaderU08Schwinn') { return this.formatType('UDD', 0, 11); }
    }

    protected toLegsType(element: Element): string {
        const shader = element.shaderName;
        // simple legs
        if (shader === 'ShaderNSlizgacz') { return 'NDWS'; }
        if (shader === 'ShaderNBox') { return 'NDGP'; }
        if (shader === 'ShaderNWalec') { return 'NDWP'; }
        if (shader === 'ShaderNStozek') { return 'NDSS'; }
        if (shader === 'ShaderNStPrzesun') { return 'NMWS'; }
        if (shader === 'ShaderNOkragla') { return 'NMWP'; }

        // frame legs
        if (shader === 'ShaderNStBox') { return 'SDGS'; }
        if (shader === 'ShaderNStScieta') { return 'SDKS'; }
        if (shader === 'ShaderNStStozek') { return 'SDSS'; }
        if (shader === 'ShaderNStGiety') { return 'SMDG'; }
        if (shader === 'ShaderNStProsta') { return 'SMGS'; }

        // skid legs
        if (shader === 'ShaderNPlozy') { return 'NMGP'; }
        return '';
    }
}
